define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var lpUtils = require('utils/lpUtils');
    var ViewController = require('web-agent-framework/ViewController');
    // var MainViewController = require('web-agent-viewControllers/MainViewController');
    var TableViewController = require('web-agent-framework/TableViewController');
    var BaseTableViewController = require('web-agent-framework/BaseTableViewController');
    var FormSelectionViewController = require('web-agent-components/FormSelectionViewController');

    var TransferViewController = ViewController.extend({
        ControllerName: 'TransferViewController',
        DATA_UPDATE_TIMEOUT: 10000,
        AGENT_MESSAGING_WAIT_FOR_ADDITIONAL_KEY_TIMEOUT: 1500,

        LPViewMap: {
            transferView: ".lpview_transfer_engagement",
            closeTransferButton: ".lpview_close_transfer",
            filterAgent: ".lpview_transfer_agent_filter",
            filterSkill: ".lpview_transfer_skill_filter",
            filterAccount: ".lpview_transfer_account_filter",
            searchField: ".lpview_search_field",
            filterAccountContainer: ".lpview_transfer_account_filter_container",
            tablesContainer: ".lpview_tables_container",
            chatAgentToName: ".lpview_agent_to_transfer_name",
            backButton: ".lpview_back_button",
            transferButton: ".lpview_transfer_button",
            cancelButton: ".lpview_cancel_button",
            nextButton: ".lpview_next_button",
            transferLine: ".lpview_result_line",
            transferAgentSkillList: ".lpview_skill_transfer_list_placeholder",
            agentToContainer: ".lpview_agent_to_transfer_container",
            agentToName: ".agent_to_name",
            skillToContainer: ".lpview_skill_to_transfer_container",
            skillToName: ".skill_to_name",
            transferringToText: '.transferring_to_text',
            errorField: ".lpview_transfer_error",
            transferToText: ".lpview_transfer_text",
            commentTextArea: ".lpview_comment_text_area",
            tabsSeparator: ".lpview_transfer_tab_separator",
            noteText: ".lpview_note_text"
        },

        LPClassMap: {
            transferTitle :".transfer_title"
        },

        LPViewClasses: {
            selected: "selected",
            disabled: "disabled",
            opened: "opened"
        },

        initialize: function (constructorData) {
            this.chatId = constructorData.chatId;
            this.visitorId = constructorData.visitorId;
            this.isMessaging = lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId);
            this.transferToMessagingAgentPermissions = lpTag.WebAgent.logicController.getAgentMessagingTransferToAgentPermissions();
            this.tabs = {};
            this.transferringTo = {};

            if (this.isMessaging) {
                initSkillsView.call(this);
                if (this.transferToMessagingAgentPermissions) {
                    initAgentsView.call(this);
                }
            } else {
                initAgentsView.call(this);
                initSkillsView.call(this);
                initRemoteAccountsView.call(this);
            }

            function initAgentsView() {
                var agentTableConfig = {
                    ControllerName: "TableViewController(TransferAgent)",
                    modelController: this.modelController,
                    filterView: this.getFirstElement(this.LPViewMap.searchField),
                    noDataTemplate: "LP_transfer_engagement_no_agents.html",
                    context: this,
                    supportKeysNavigation: true,
                    focusedView: this.getFirstElement(this.LPViewMap.filterAgent),
                    // chat configuration
                    modelPath: "agent.availableAgents.agents",
                    rowTemplateFile: "LP_transfer_engagement_line_by_agent.html",
                    dataBinder: this.agentsDataBinder,
                    dataRenderer: this.agentsDataRenderer,
                    rowsSortFunction: lpUtils.getSortFunction('userName'),

                };
                if (this.isMessaging) {
                    agentTableConfig.modelPath = "agent.messagingAgents.agents";
                    agentTableConfig.rowTemplateFile = "LP_transfer_engagement_line_by_agent_messaging.html";
                    agentTableConfig.dataBinder = this.messagingAgentsDataBinder;
                    agentTableConfig.dataRenderer = this.messagingAgentsDataRenderer;
                    agentTableConfig.rowsSortFunction = lpUtils.getSortFunction('statusNameSort');
                    agentTableConfig.ignoreRowHover = true;
                    agentTableConfig.preventSubmitByEnter = true;
                    agentTableConfig.supportKeysNavigation = false;
                    agentTableConfig.WAIT_FOR_ADDITIONAL_KEY_TIMEOUT = this.AGENT_MESSAGING_WAIT_FOR_ADDITIONAL_KEY_TIMEOUT;
                    agentTableConfig.rowSelectedCallback = this.transferMessagingAgentLineSelected;
                    agentTableConfig.lineClicked = this.transferMessagingAgentLineClicked;
                }

                this.agentsTable = new TableViewController(agentTableConfig);

                this.addViewController({
                    viewController: this.agentsTable,
                    target: this.LPViewMap.tablesContainer,
                    hidden: true
                });

                this.lpShow(this.LPViewMap.filterAgent);
                this.tabs[this.transferModes.transferToAgent] = {view: this.agentsTable, filter: this.LPViewMap.filterAgent};
            }

            function initSkillsView() {
                var skillTableConfig = {
                    ControllerName: "TableViewController(TransferSkill)",
                    modelController: this.modelController,
                    filterView: this.getFirstElement(this.LPViewMap.searchField),
                    modelPath: "chats." + this.chatId + ".transferChat.availableSkills",
                    rowTemplateFile: "LP_transfer_engagement_line_by_skill.html",
                    noDataTemplate: "LP_transfer_engagement_no_skill.html",
                    dataRenderer: this.skillsDataRenderer,
                    dataBinder: this.skillsDataBinder,
                    rowsSortFunction: lpUtils.getSortFunction('name'),
                    context: this,
                    supportKeysNavigation: true,
                    focusedView: this.getFirstElement(this.LPViewMap.filterSkill)
                };
                if (this.isMessaging) {
                    skillTableConfig.ignoreRowHover = true;
                    skillTableConfig.dataBinder = this.messagingSkillsDataBinder;
                    skillTableConfig.rowSelectedCallback = this.transferMessagingSkillLineSelected;
                    skillTableConfig.preventSubmitByEnter = true;
                }

                this.skillsTable = new TableViewController(skillTableConfig);

                this.addViewController({viewController: this.skillsTable, target: this.LPViewMap.tablesContainer});


                if (!lpTag.WebAgent.logicController.isLE2()) {
                    this.addClass(this.LPViewMap.tablesContainer, 'no_le2');
                }

                this.lpShow(this.LPViewMap.filterSkill);
                this.tabs[this.transferModes.transferToSkill] = {view: this.skillsTable, filter: this.LPViewMap.filterSkill};
            }

            function initRemoteAccountsView() {
                this.accountToAccountFeatureIsOn = lpTag.WebAgent.logicController.hasAccountToAccountFeature();
                if (this.accountToAccountFeatureIsOn) {
                    this.lpShow(this.LPViewMap.filterAccountContainer);
                    this.remoteAccountSkillsTable = new TableViewController({
                        ControllerName: "TableViewController(TransferAccount)",
                        modelController: this.modelController,
                        filterView: this.getFirstElement(this.LPViewMap.searchField),
                        modelPath: "chats." + this.chatId + ".transferChat.availableRemoteAccountSkills",
                        rowTemplateFile: "LP_transfer_engagement_line_account.html",
                        noDataTemplate: "LP_transfer_engagement_no_account.html",
                        dataRenderer: this.remoteAccountSkillsDataRenderer,
                        dataBinder: this.remoteAccountSkillsDataBinder,
                        rowsSortFunction: lpUtils.getSortFunction('name'),
                        context: this,
                        supportKeysNavigation: true,
                        focusedView: this.getFirstElement(this.LPViewMap.filterAccount)
                    });
                    this.addViewController({
                        viewController: this.remoteAccountSkillsTable,
                        target: this.LPViewMap.tablesContainer
                    });
                    this.lpShow(this.LPViewMap.filterAccount);
                    this.tabs[this.transferModes.transferToAccount] = {view: this.remoteAccountSkillsTable, filter: this.LPViewMap.filterAccount};
                }
            }

            if (lpTag.WebAgent.logicController.isEngagementAsyncMessaging(this.chatId)) {
                this.addClass(this.LPViewMap.transferView, 'messaging');
                // we have two titles..
                $(this.LPClassMap.transferTitle, this.view).html(this.translate('transferConversationTitle'));
                this.getFirstElement(this.LPViewMap.noteText).innerHTML = this.translate('transferWillCloseConversation');
            }

            // i'm sorry for this...
            if (Object.keys(this.tabs).length > 1) {
                this.lpShow(this.LPViewMap.tabsSeparator);
            }
            else {
                this.lpHide(this.LPViewMap.tabsSeparator);
            }
        },

        events: function () {
            var participantPath = lpTag.WebAgent.logicController.getParticipantPath(this.visitorId);
            this.bindModel({modelPath: participantPath + ".participantTag", callback: this.handleTagChanged});

            this.bindViewEvent({
                selector: this.LPViewMap.closeTransferButton,
                DOMEvent: "click",
                callback: this.closeTransferClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.filterSkill,
                DOMEvent: "click",
                callback: this.filterBySkillClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.filterAgent,
                DOMEvent: "click",
                callback: this.filterByAgentClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.filterAccount,
                DOMEvent: "click",
                callback: this.filterByAccountClicked
            });
            this.bindViewEvent({
                DOMEvent: "click",
                callback: this.viewClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.searchField,
                DOMEvent: "click",
                callback: this.searchClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.backButton,
                DOMEvent: "click",
                callback: this.backButtonClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.cancelButton,
                DOMEvent: "click",
                callback: this.closeTransferClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.nextButton,
                DOMEvent: "click",
                callback: this.nextButtonClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.transferButton,
                DOMEvent: "click",
                callback: this.transferButtonClicked
            });
            this.bindViewEvent({
                selector: this.LPViewMap.transferView,
                DOMEvent: "keydown",
                callback: this.keyDownPressed
            });
        },

        render: function () {
            this.selectFilter(this.transferModes.transferToSkill); //default mode is transfer 'toSkill'
            var searchField = this.getFirstElement(this.LPViewMap.searchField);
            searchField.tabIndex = 1;
            searchField = null;
        }
    });

    TransferViewController.prototype.chatStates = {
        offline: "1",
        online: "2",
        occupied: "3",
        away: "4"
    };

    TransferViewController.prototype.CLASS_STATE_NAMES = {
        OFFLINE: "offline",
        ONLINE: "online",
        OCCUPIED: "occupied",
        AWAY: "away"
    };


    TransferViewController.prototype.messagingStates = {
        offline: "OFFLINE",
        online: "ONLINE",
        backSoon: "BACK_SOON",
        away: "AWAY"
    };

    TransferViewController.prototype.transferModes = {
        transferToAgent: "toAgent",
        transferToSkill: "toSkill",
        transferToAccount: "toAccount",
        transferToAll: "toAll" //currently disabled
    };

    TransferViewController.prototype.ANIMATION_DURATION = 200;

    TransferViewController.prototype.PAGES = {
        transferTables: ".lpview_page_transfer_tables",
        transferView: ".lpview_page_transfer_view",
        loading: ".lpview_page_loading"
    };

    TransferViewController.prototype.transferStates = {
        success: "success",
        error: "error"
    };

    TransferViewController.prototype.searchClicked = function (e) {
        this.stopPropagation(e);
        this.touchSession();
    };

    TransferViewController.prototype.viewClicked = function () {
        this.setFocusAnchor();
    };

    TransferViewController.prototype.showPage = function (pageId) {
        if (!pageId) {
            return;
        }
        if (this.activePageId) {
            this.lpHide(this.activePageId);
        } else {
            for (var index in this.PAGES) {
                if (this.PAGES.hasOwnProperty(index)) {
                    this.lpHide(this.PAGES[index]);
                }
            }
        }

        this.activePageId = pageId;
        this.lpShow(this.activePageId);
    };

    TransferViewController.prototype.backButtonClicked = function () {
        this.showPage(this.PAGES.transferTables);
        this.addClass(this.getFirstElement(this.LPViewMap.skillToContainer), "hide");
        this.addClass(this.getFirstElement(this.LPViewMap.agentToContainer), "hide");
        this.updateTransferList();
    };

    TransferViewController.prototype.transferButtonClicked = function () {
        // gets the current chat dependencies
        var activeDependencies = lpTag.WebAgent.logicController.getEngagementDependantActiveChannels(this.visitorId, lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.CHAT);

        // for now we only support the 'Co-Browse' dependencies.
        // we need to figure a strategy to show the appropriate message in the dialog
        // that can support multi-channels.
        if (activeDependencies && activeDependencies.length === 1 && activeDependencies[0].channelName === lpTag.WebAgent.logicController.ENGAGEMENT_CHANNELS.COBROWSE) {

            // Closing the channels.

            this.showDialog({
                title: this.translate("AreYouSure"),
                description: this.translate("COBROWSE_TRANSFER_DIALOG_MESSAGE"),
                targetView: window.MainViewControllerBody,
                modal: true,
                xEnabled: true,
                okButton: this.translate('ok'),
                cancelButton: this.translate('cancel'),
                okCallback: this.startTransfer.bind(this)
            });
        } else {
            this.startTransfer();
        }
    };


    TransferViewController.prototype.startTransfer = function () {
        this.hideErrorMessage();
        this.showPage(this.PAGES.loading);

        var that = this;

        this.modelController.setAgentTyping({
            chatId: that.chatId,
            typing: false,
            success: that.transferChat,
            error: that.transferChat,
            context: that
        });
    };

    TransferViewController.prototype.transferChat = function () {
        var that = this;

        var transferData = {
            chatId: that.chatId,
            success: function (data) {
                that.transferCompleted.call(that, data);
            },
            error: function (data) {
                that.transferCompleted.call(that, data);
            }
        };

        var commentTextArea = this.getFirstElement(this.LPViewMap.commentTextArea);
        transferData.text = (commentTextArea && commentTextArea.value) || undefined;

        var retryData = this.retryData || {};

        switch (this.transferMode) {
            case this.transferModes.transferToAgent :
                transferData.agentId = this.transferringTo["@id"] || this.transferringTo.agentId || retryData.agentId;
                transferData.skillId = this.transferringTo.skillId || retryData.skillId;
                this.modelController.transferChat(transferData);
                break;
            case this.transferModes.transferToSkill:
                transferData.skillId = this.transferringTo.id || retryData.id;
                this.modelController.transferChat(transferData);
                break;
            case this.transferModes.transferToAccount:
                transferData.skillId = this.transferringTo.id || retryData.id;
                this.modelController.transferChatToRemoteAccount(transferData);
                break;
            default :
                break;
        }
    };

    TransferViewController.prototype.transferCompleted = function (data) {
        if (data && data.error) {
            var errorMessage, errorCode;
            if (this.isMessaging) {
                errorCode = lpTag.WebAgent.transferController.getTransferErrorCode(data.error, this.transferringTo) || 'default';
                errorMessage = this.translate('transferToAgent.error.' + errorCode);
                this.retryData = (!_.isEmpty(this.transferringTo) && lpUtils.cloneObject(this.transferringTo)) || this.retryData;
            } else {
                var transferTargetText = this.transferringTo && (this.transferringTo.userName || this.transferringTo.agentName || this.transferringTo.name) || '';
                var target = this.sanitizeText(transferTargetText);
                errorMessage = this.translateObj('transferErrorTargetUnavailable', [{ key: (target && target.text) || '' }]);
            }
            this.showErrorMessage(errorMessage);
            this.showPage(this.PAGES.transferView);
            this.updateTransferList();
        } else {
            //We can get here with a **disposed** TransferViewController (=this), so we will not have a this.visitorId nor this.viewEventsHandler!!
            var visitorId = this.modelController.getModelParam('chats.' + data.chatId + '.visitorInfo.visitorId');
            lpTag.WebAgent.logicController.disposeParticipant(visitorId);
            ViewController.viewEventsHandler.fireEvent({
                appName: visitorId,
                UIEvent: this.eventType.VISITOR_DISPOSED,
                eventData: {visitorId: visitorId},
                deleteOnFire: true
            });
        }
    };

    TransferViewController.prototype.transferMessagingAgentLineClicked = function (data) {
        this.clearDataUpdateTimeout();
        // same row clicked
        if (this.transferringTo && this.transferringTo.agentId && this.transferringTo.agentId === data.rowData.agentId && this.transferringTo.skillList) {
            this.transferringTo.opened = !this.transferringTo.opened;
            this.toggleClass(this.getFirstElement(this.LPViewMap.transferLine, data.view), this.LPViewClasses.opened, this.transferringTo.opened);
        }
    };

    TransferViewController.prototype.transferMessagingAgentLineSelected = function (data) {
        this.clearDataUpdateTimeout();

        this.transferringTo = this.transferringTo || {};
        // same row selected
        if (this.transferringTo.agentId && this.transferringTo.agentId === data.rowData.agentId) {
            // in case of re-rendering because of filter- add the view controller to the view again and re-apply the toggle state
            this._initializeAgentRow(data);
            return;
        }

        // different row- clear previous row skillList
        if (this.transferringTo.skillList) {
            this.transferringTo.skillList.dispose();
        }

        this.transferringTo = {};
        this.transferringTo.agentId = data.rowData.agentId;
        this.transferringTo.agentName = data.rowData.agentName;
        var agentTransferableSkills = lpTag.WebAgent.transferController.getAllowedAgentSkillsForTransfer(this.chatId, data.rowData.agentSkills);

        // skill handling
        if (agentTransferableSkills.length === 1) {
            _setTransferSkill(this, agentTransferableSkills[0]);
        }
        else {
            _handleSkillList(this);
        }
        this.removeClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled);

        /////// private functions ///////
        function _setTransferSkill(context, skill) {
            skill = (skill && skill.rowData) || skill || {};
            context.transferringTo.skillId = skill.skillId;
            context.transferringTo.skillName = skill.skillName || context.translate("notAvailable");
        }

        function _handleSkillList(context) {
            _.forEach(agentTransferableSkills, function (skill) {
                skill.value = skill.skillName;
                skill.description = skill.skillDescription || context.translate("notAvailable");
                skill.checked = false;
            });
            // select first row by default, if current skill included- mark it
            agentTransferableSkills[0].checked = true;
            if (agentTransferableSkills[0].isCurrentSkill) {
                agentTransferableSkills[0].addSeperator = true;
                agentTransferableSkills[0].subtext = '(' + context.translate('currentConversationSkill') + ')';
            }
            _setTransferSkill(context, agentTransferableSkills[0]);

            var skillListComponent = createSkillList(context);
            context.addViewController({ viewController: skillListComponent, target: context.getFirstElement(context.LPViewMap.transferAgentSkillList, data.view) });
            context.transferringTo.opened = true;
            context.addClass(context.getFirstElement(context.LPViewMap.transferLine, data.view), context.LPViewClasses.opened);
            context.transferringTo.skillList = skillListComponent;

            function createSkillList(context) {
                return new FormSelectionViewController({
                    ControllerName: 'transferList',
                    selectionOptions: agentTransferableSkills,
                    selectionType: "radio",
                    selectionClickedCallback: _setTransferSkill.bind(null, context),
                    tooltipPosition: 'bottom',
                    modifyData: true,
                    rowPrefix: 'INNER_' + context.agentsTable.rowPrefix,
                    context: context
                });
            }
        }
    };

    TransferViewController.prototype.nextButtonClicked = function (data) {
        if (!this.hasSingleClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled)) {
            this.clearDataUpdateTimeout();
            this.showPage(this.PAGES.transferView);
            this.setTransferTo({
                agent: this.transferringTo.userName || this.transferringTo.agentName,
                skill: this.transferringTo.name || this.transferringTo.skillName
            });
            this.hideErrorMessage();
        }
    };

    TransferViewController.prototype.transferLineClicked = function (data) {
        if (typeof data.rowData.onlineAgents !== "undefined" && !data.rowData.onlineAgents) { // No available agents for transfer
            if (typeof data.rowData.allowNotOnlineTransfer !== "undefined") { // Check if this is an A2A transfer line
                if (!data.rowData.allowNotOnlineTransfer) { // Act according to A2A configuration
                    return;
                }
            } else { // Ignore transfer request
                return;
            }
        }

        if (data.rowData.allowNotOnlineTransfer === false && data.rowData.onlineAgents === "0" || // This is written explicitly since it can be undefined for some flows
            typeof data.rowData.onlineAgents !== "undefined" && data.rowData.onlineAgents === "0") {
            return;
        }
        this.clearDataUpdateTimeout();
        this.transferringTo = data.rowData;
        this.showPage(this.PAGES.transferView);
        this.getFirstElement(this.LPViewMap.commentTextArea).focus();
        this.getFirstElement(this.LPViewMap.commentTextArea).value = '';
        this.setTransferTo({
            agent: this.transferringTo.userName,
            skill: this.transferringTo.name
        });
        this.hideErrorMessage();
    };

    TransferViewController.prototype.setTransferTo = function (transferData) {
        var loadingTransferTo = this.getFirstElement(this.LPViewMap.transferringToText);
        loadingTransferTo.innerText = '';
        transferData = transferData || {};
        if (transferData.agent) {
            this.removeClass(this.getFirstElement(this.LPViewMap.agentToContainer), "hide");
            var agentTo = this.getFirstElement(this.LPViewMap.agentToName);
            agentTo.innerText = transferData.agent;
            loadingTransferTo.innerText += transferData.agent;
        } else {
            this.addClass(this.getFirstElement(this.LPViewMap.agentToContainer), "hide");
        }
        if (transferData.skill) {
            this.removeClass(this.getFirstElement(this.LPViewMap.skillToContainer), "hide");
            var skillTo = this.getFirstElement(this.LPViewMap.skillToName);
            skillTo.innerText = transferData.skill;
            if (transferData.agent) {
                loadingTransferTo.innerText += ' (' + transferData.skill + ')';
            } else {
                loadingTransferTo.innerText += transferData.skill;
            }
        } else {
            this.addClass(this.getFirstElement(this.LPViewMap.skillToContainer), "hide");
        }
    };

    TransferViewController.prototype.hideErrorMessage = function () {
        this.lpHide(this.LPViewMap.errorField);
    };

    TransferViewController.prototype.showErrorMessage = function (errorMessage) {
        var error = this.getFirstElement(this.LPViewMap.errorField);
        if (error) {
            error.innerHTML = errorMessage;
        }
        this.lpShow(this.LPViewMap.errorField);
    };

    /**
     * Selecting the filter
     * @param filterName
     */
    TransferViewController.prototype.selectFilter = function (transferMode) {
        if (this.isMessaging){
            _.forEach(this.tabs, function (tab) {
                return tab.view && tab.view.clearSelection();
            });
            this.addClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled);
        }

        this.transferMode = transferMode;

        if (this.selectedFilter) {
            this.removeClass(this.selectedFilter, this.LPViewClasses.selected);
        }

        for (var key in this.tabs) {
            if (key === transferMode) {
                this.selectedFilter = this.tabs[key].filter;
                this.tabs[key].view.lpShow();
            } else {
                this.tabs[key].view.lpHide();
            }
        }

        this.addClass(this.selectedFilter, this.LPViewClasses.selected);
    };

    TransferViewController.prototype.filterByAgentClicked = function () {
        this.selectFilter(this.transferModes.transferToAgent);
    };

    TransferViewController.prototype.filterBySkillClicked = function () {
        this.selectFilter(this.transferModes.transferToSkill);
    };

    TransferViewController.prototype.filterByAccountClicked = function () {
        this.selectFilter(this.transferModes.transferToAccount);
    };

    TransferViewController.prototype.handleTagChanged = function (data) {
        if (typeof(data.newValue) === 'undefined' || this.disposed) {
            return;
        }
        if (this.color) {
            this.removeClass(this.getFirstElement(this.LPViewMap.transferView), this.color);
        }
        this.color = data.newValue;
        this.addClass(this.getFirstElement(this.LPViewMap.transferView), this.color);
        for (var key in this.tabs) {
            this.tabs[key].view.changeHighlightColor(this.color);
        }
    };

    TransferViewController.prototype.closeTransferClicked = function () {
        this.lpHide();
    };

    TransferViewController.prototype.updateTransferTables = function () {
        this.getFirstElement(this.LPViewMap.transferToText).innerHTML = this.translate("loadingAgentsAndSkills");
        this.showPage(this.PAGES.loading);
        var that = this;
        this.updateTransferList(function (data) {
            if (data && data.error) {
                that.addClass(that.PAGES.loading, that.transferStates.error);
                that.getFirstElement(that.LPViewMap.transferToText).innerHTML = that.translate("transferFailedToRetrieveData");
                that = null;
                return;
            }
            that.removeClass(that.PAGES.loading, that.transferStates.error);
            that.showPage(that.PAGES.transferTables);
            that.getFirstElement(that.LPViewMap.transferToText).innerHTML = that.translate("transferEngagementTo");
            that.selectFilter.call(that, that.transferMode);
            that = null;
        });
    };

    TransferViewController.prototype.setDataUpdateTimeout = function () {
        var that = this;
        this.clearDataUpdateTimeout();
        this.updateTimeout = setTimeout(function () {
            that.updateTransferList();
            that.setDataUpdateTimeout();
        }, this.DATA_UPDATE_TIMEOUT);
    };

    TransferViewController.prototype.clearDataUpdateTimeout = function () {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
            this.updateTimeout = null;
        }
    };

    /**
     * The focus anchor is the focused link for transfer,
     * It is used for table navigation up/down keys.
     */
    TransferViewController.prototype.setFocusAnchor = function () {
        var that = this;
        setTimeout(function () { // Added a timeout to the focus event to make sure the element is visible first (IE8 bugs)
            var focusAnchor;
            switch (that.transferMode) {
                case that.transferModes.transferToAgent:
                    focusAnchor = that.LPViewMap.filterAgent;
                    break;
                case that.transferModes.transferToSkill:
                    focusAnchor = that.LPViewMap.filterSkill;
                    break;
                default:
                    break;
            }
            that.focus(focusAnchor);
        }, 0);
    };

    TransferViewController.prototype.skillsDataRenderer = {
        numberOfSections: function (data) {
            return data.length > 0 ? 1 : 0;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            return;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var value = {};

            value.id = rowData.id;
            value.rowData = rowData;
            value.text = rowData.name || "";
            value.textTooltip = this.getModelParam("skills.data." + rowData.id + ".description") || value.text;

            if (lpTag.WebAgent.transferController.canTransferToSkills(this.chatId, value.id)) {
                if (rowData.onlineAgents) {
                    value.onlineAgentsCount = rowData.onlineAgents;
                    value.onlineAgentsCountTooltip = rowData.onlineAgents + " - " + this.translate("onlineAgents");
                }

                if (rowData.waitTime && !(rowData.waitTime.error || rowData.waitTime.expectedWaitTimeSec <= -1)) {
                    value.waitTimeState = '';
                    value.waitTime = lpUtils.formatTimeFromSeconds(rowData.waitTime.expectedWaitTimeSec, true);
                    value.waitTimeTooltip = this.translateObj('transfer_by_skill_expected_wait_time', [{
                        isTranslate: false,
                        key: value.waitTime
                    }]);
                } else {
                    value.waitTimeTooltip = this.translate('transfer_by_skill_no_wait_time');
                    value.waitTimeState = 'error';
                    value.waitTime = "";
                }

                value.disabled = value.rowData.onlineAgents == "0" ? this.LPViewClasses.disabled : "";
                return value;
            }
        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }
            var split = filterText.toLowerCase().split(' ');
            for (var index = 0; index < split.length; index++) {
                var partialTitle = data.name.toLowerCase().indexOf(split[index]) >= 0;
                if (!partialTitle) {
                    return true;
                }
            }
            return false;
        },
        getPropertiesForHighlight: function () {
            return {text: true};
        }
    };

    TransferViewController.prototype.messagingSkillsDataBinder = {
        operationCanceled: function () {
            this.closeTransferClicked();
        },
        // for keyup navigation
        rowSelected: function (data) {
            this.transferMessagingSkillLineSelected(data);
        },
        keyDown: function (keyCode) {
            if (keyCode === 13 && this.transferringTo) {
                this.nextButtonClicked();
            }
        },
        rowClicked: function () {
            this.focus(this.LPViewMap.filterSkill);
        },
        clearSelectionCallback: function (data) {
            this.transferringTo = {};
            this.addClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled);
        },
        modelDataChanged: function modelDataChanged() {
            this.skillsTable.refreshSelected();
        }
    };

    TransferViewController.prototype.transferMessagingSkillLineSelected = function (data) {
        var skillData = (data && data.rowData) || data || {};

        this.transferringTo = {
            id: skillData.id,
            name: skillData.name
        };
        this.removeClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled);
    };

    TransferViewController.prototype.skillsDataBinder = {
        operationCanceled: function () {
            this.closeTransferClicked();
        },
        rowClicked: function (data) {
            this.transferLineClicked(data);
        }
    };

    TransferViewController.prototype.agentsDataRenderer = {
        numberOfSections: function (data) {
            return data.length > 0 ? 1 : 0;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            return;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var agentChatState = rowData["@chatState"];
            var agentAvailable = !(agentChatState == this.chatStates.offline || agentChatState == this.chatStates.away);
            var value = {
                state: "",
                stateTooltip: "",
                text: "",
                details: "",
                rowData: rowData,
                accountName: "",
                id: rowData["@id"]
            };
            var maxChatsReached = rowData["@maxChats"] === rowData.chats;
            var isCurrentAgent = rowData.userName === this.modelController.getModelParam("agent.displayName");

            if (lpTag.WebAgent.transferController.canTransferToSkills(this.chatId, rowData.skills && rowData.skills.skill) &&
                !isCurrentAgent && agentAvailable) {
                switch (agentChatState) {
                    case this.chatStates.online:
                        value.state = maxChatsReached ? "onlineMaxChats" : "online";
                        value.stateTooltip = this.translate("online");
                        break;
                    case this.chatStates.occupied:
                        value.state = maxChatsReached ? "occupiedMaxChats" : "occupied";
                        value.stateTooltip = this.translate("backIn5");
                        break;
                    default:
                        break;
                }
                if (maxChatsReached) {
                    value.stateTooltip += "&#13;" + this.translate("maxChatsReached");
                }
                value.text = rowData.userName || "";
                value.textTooltip = value.text;
                value.accountTooltip = "";

                if (rowData.skillsInfo) {
                    var skillsInfo = rowData.skillsInfo;

                    value.detailsTooltip = "";
                    if (skillsInfo.skillInfo.constructor == Array) {
                        value.details = skillsInfo.skillInfo.length + " " + this.translate("skills");

                        value.detailsTooltip += value.details + ":&#13;&#13;";
                        for (var i = 0; i < skillsInfo.skillInfo.length; i++) {
                            value.detailsTooltip += lpUtils.escapeHTML(skillsInfo.skillInfo[i].name) + (i < skillsInfo.skillInfo.length - 1 ? ", &#13; " : '');
                        }
                    } else {
                        value.details = skillsInfo.skillInfo.name;
                        value.detailsTooltip = value.details;
                    }
                } else {
                    value.details = this.translate("noSkillFound");
                }
                value.lineType = "by_agent";
                value.disabled = "";
                return value;
            }
        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }

            var split = filterText.toLowerCase().split(' ');

            for (var index = 0; index < split.length; index++) {
                var partialTitle;
                if (data.userName) {
                    partialTitle = data.userName.toLowerCase().indexOf(split[index]) >= 0;
                }
                if (!partialTitle) {
                    return true;
                }
            }

            return false;
        },
        getPropertiesForHighlight: function () {
            return {text: true};
        }
    };

    TransferViewController.prototype.messagingAgentsDataRenderer = {
        numberOfSections: function (data) {
            return data.length > 0 ? 1 : 0;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            return;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var agentChatState = rowData.agentPresence ? rowData.currentStatus : this.messagingStates.offline;
            var value = {
                state: "",
                stateTooltip: "",
                text: "",
                details: "",
                rowData: rowData,
                accountName: "",
                id: rowData.agentId,
                hasMoreSkills: "",
                // isOverloaded: "",
                // overloadedTooltip: this.translate("overloadedAgent"),
                toggleIconTooltip: ""
            };
            var isCurrentAgent = rowData.agentName == this.modelController.getModelParam("agent.displayName");
            var isAlreadyParticipant = !!lpTag.WebAgent.logicController.getParticipantInConversation(this.chatId, rowData.agentId);

            var agentTransferableSkills = lpTag.WebAgent.transferController.getAllowedAgentSkillsForTransfer(this.chatId, rowData.agentSkills);
            var isTargetAgentStateAllowed = this.transferToMessagingAgentPermissions && this.transferToMessagingAgentPermissions[(agentChatState + '').toLowerCase()];

            if (agentTransferableSkills.length && !isCurrentAgent && !isAlreadyParticipant && isTargetAgentStateAllowed) {
                switch (agentChatState) {
                    case this.messagingStates.online:
                        value.state = this.CLASS_STATE_NAMES.ONLINE;
                        value.stateTooltip = this.translate("online");
                        break;
                    case this.messagingStates.backSoon:
                        value.state = this.CLASS_STATE_NAMES.OCCUPIED;
                        value.stateTooltip = this.translate("back_soon");
                        break;
                    case this.messagingStates.away:
                        value.state = this.CLASS_STATE_NAMES.AWAY;
                        if (rowData.currentStatusReason) {
                            value.stateTooltip = lpTag.WebAgent.logicController.getAgentStatusReasonById(rowData.currentStatusReason);
                        } else {
                            value.stateTooltip = this.translate("away");
                        }
                        break;
                    case this.messagingStates.offline:
                        value.state = this.CLASS_STATE_NAMES.OFFLINE;
                        value.stateTooltip = this.translate("offline");
                        break;
                    default:
                        break;
                }
                value.text = rowData.agentName || "";
                value.textTooltip = value.text;

                // value.isOverloaded = rowData.load > 90 ? "" : "hidden";

                value.detailsTooltip = "";
                if (agentTransferableSkills.length > 1) {
                    value.details = agentTransferableSkills.length + " " + this.translate("skills");
                    value.detailsTooltip = value.details + ':';
                    _.forEach(agentTransferableSkills, function (skill) {
                        value.detailsTooltip += "&#13;"; // new line
                        value.detailsTooltip += lpUtils.escapeHTML(skill.skillName);

                    });
                }
                else  {
                    value.details = agentTransferableSkills[0].skillName || this.translate("notAvailable"); // in case of skillId -1
                    value.detailsTooltip = agentTransferableSkills[0].skillDescription || this.translate("notAvailable");
                    value.hasMoreSkills = "hidden";
                }

                return value;
            }
        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }

            var split = filterText.toLowerCase().split(' ');

            for (var index = 0; index < split.length; index++) {
                var partialTitle;
                if (data.agentName) {
                    partialTitle = data.agentName.toLowerCase().indexOf(split[index]) >= 0;
                }
                if (!partialTitle) {
                    return true;
                }
            }

            return false;
        },
        getPropertiesForHighlight: function () {
            return { text: true };
        }
    };

    TransferViewController.prototype.agentsDataBinder = {
        operationCanceled: function () {
            this.closeTransferClicked();
        },
        rowClicked: function (data) {
            this.transferLineClicked(data);
        }
    };

    TransferViewController.prototype.messagingAgentsDataBinder = {
        operationCanceled: function () {
            this.closeTransferClicked();
        },
        clearSelectionCallback: function (data) {
            // same row clicked- don't dispose selection data
            if (data && data.rowData && data.rowData.agentId === (this.transferringTo && this.transferringTo.agentId)) {
                return;
            }
            if (this.transferringTo && this.transferringTo.skillList) {
                this.transferringTo.skillList.dispose();
            }
            this.transferringTo = {};

            if (!this.updateTimeout) {
                this.setDataUpdateTimeout();
            }
            this.addClass(this.getFirstElement(this.LPViewMap.nextButton), this.LPViewClasses.disabled);
        },
        rowInitialized: function (data) {
            this._initializeAgentRow(data);
        },
        modelDataChanged: function () {
            var selectedRowIndexData = this.agentsTable.getSelectedRowData();
            if (this.transferringTo.agentId != (selectedRowIndexData && selectedRowIndexData.id)) {
                this.agentsTable.clearSelection();
            }
        }
    };

    TransferViewController.prototype._initializeAgentRow = function (data) {
        // same row selcted after re-rendering: re-apply the skill list with the toggle state if needed
        var sameAgentSelected = this.transferringTo && this.transferringTo.agentId && this.transferringTo.agentId === data.rowData.agentId;
        var skillListView = this.getFirstElement(this.LPViewMap.transferAgentSkillList, data && data.view);
        var skillListNotRendered = this.transferringTo.skillList && skillListView && skillListView.children && !skillListView.children.length;

        if (sameAgentSelected && skillListNotRendered) {
            this.addViewController({ viewController: this.transferringTo.skillList, target: skillListView });
            this.toggleClass(this.getFirstElement(this.LPViewMap.transferLine, data && data.view), this.LPViewClasses.opened, this.transferringTo.opened);
            return;
        }
    };

    TransferViewController.prototype.remoteAccountSkillsDataRenderer = {
        numberOfSections: function (data) {
            return data.length > 0 ? 1 : 0;
        },
        numberOfRowsInSection: function (data, sectionIndex) {
            return data.length;
        },
        dataForSection: function (data, sectionIndex) {
            return;
        },
        dataForRowInSection: function (data, rowIndex, sectionIndex) {
            var rowData = data[rowIndex];
            var value = {};
            value.id = rowData.id;
            value.text = rowData.name || "";
            value.textTooltip = "";
            value.accountTooltip = value.text;
            value.accountName = rowData.accountName || "";
            value.details = rowData.onlineAgents + "";
            value.detailsTooltip = value.details + " - " + this.translate("onlineAgents") + " &#13; ";
            value.detailsTooltip += rowData.loggedInAgents + " - " + this.translate("loggedInAgents") + " &#13; ";
            value.detailsTooltip += this.parseSecondsToTime(rowData.averageWaitTime) + " - " + this.translate("averageWaitTime");
            value.disabled = !rowData.allowNotOnlineTransfer && !rowData.onlineAgents ? this.LPViewClasses.disabled : "";

            return value;

        },
        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }
            var split = filterText.toLowerCase().split(' ');
            for (var index = 0; index < split.length; index++) {
                var partialTitle = data.name.toLowerCase().indexOf(split[index]) >= 0 || data.accountName.toLowerCase().indexOf(split[index]) >= 0;
                if (!partialTitle) {
                    return true;
                }
            }
            return false;
        },
        getPropertiesForHighlight: function () {
            return {
                text: true,
                accountName: true
            };
        }
    };

    TransferViewController.prototype.remoteAccountSkillsDataBinder = {
        operationCanceled: function () {
            this.closeTransferClicked();
        },
        rowClicked: function (data) {
            this.transferLineClicked(data);
        }
    };

    TransferViewController.prototype.updateChatId = function (chatId) {
        this.chatId = chatId;
        this.skillsTable.updateModelPath("chats." + this.chatId + ".transferChat.availableSkills");
        if (this.accountToAccountFeatureIsOn) {
            this.remoteAccountSkillsTable.updateModelPath("chats." + this.chatId + ".transferChat.availableRemoteAccountSkills");
        }
    };

    TransferViewController.prototype.lpShow = function (view) {
        if (!view || view == this.view) {
            if (!this.visible) {
                for (var key in this.tabs) {
                    this.tabs[key].view.clearSelection();
                }
                ViewController.prototype.lpShow.call(this, view, null, false);
            }
            this.updateTransferTables();
        } else {
            ViewController.prototype.lpShow.call(this, view);
        }

        if (this.activePageId === this.PAGES.transferTables) {
            this.setFocusAnchor();
        }
    };

    TransferViewController.prototype.lpHide = function (view) {
        if (!view || view === this.view) {
            if (this.visible) {
                this.removeClass(this.PAGES.loading, this.transferStates.error);
                this.setTransferTo();
                for (var key in this.tabs) {
                    this.tabs[key].view.lpHide();
                }
                this.viewEventsHandler.fireEvent({appName: this.visitorId, UIEvent: "transferViewClosed"});
                ViewController.prototype.lpHide.call(this, view, null, false);
                this.clearDataUpdateTimeout();
            }
        } else {
            ViewController.prototype.lpHide.call(this, view);
        }
    };

    TransferViewController.prototype.updateTransferList = function (callback) {
        if(this.modelController) {
            this.modelController.updateTransferDataForChat({
                chatId: this.chatId,
                done: callback
            });
            this.setDataUpdateTimeout();
        }
    };


    TransferViewController.prototype.keyDownPressed = function (e) {
        var keyCode = e.keyCode || e.which;
        switch (keyCode) {
            case 27 /* ESC */
            :
                this.closeTransferClicked();
                break;
        }
    };


    return TransferViewController;

});
